import { render, staticRenderFns } from "./ProductTemplateField.vue?vue&type=template&id=205bb03d"
import script from "./ProductTemplateField.vue?vue&type=script&lang=js"
export * from "./ProductTemplateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports